<div class="popup-container">

    <header>
        <label class="close_button" (click)="close()">x</label>
        <div class="header d-block roboto-medium">
            <label class="ms-3 mt-3 mb-3">{{heading}}</label>
        </div>
    </header>
    <div>
        <ag-grid-angular class="ag-theme-balham grid-items ms-3 mt-3 viewcommentcomp "
            (gridReady)="onGridReady($event);" (window:resize)="sizeToFit()" [animateRows]="true" [headerHeight]="35"
            [floatingFiltersHeight]="35" [defaultColDef]="defaultColDef" [columnDefs]="columnDef"
            [rowData]="displayRowData" [context]="context" [icons]="icons" [gridOptions]="gridOptions"
            [rowClassRules]="rowClassRules">
        </ag-grid-angular>
    </div>
</div>